<template>
  <v-container grid-list-xl pa-0>
    <h2 class="my-3 title">Our Vendors</h2>
    <v-layout row wrap align-center justify-center>
      <v-flex v-for="(vendor, index) in vendors" :key="index" xs12 md6>
        <v-card class="elevation-2">
          <div class="text-xs-center pt-4">
            <v-icon x-large>{{ vendorIcon(vendor.contractor_type) }}</v-icon>
          </div>
          <v-card-title primary-title>
            <h3 class="title mb-0 text-uppercase">
              {{ vendor.contractor_type }}
            </h3>
          </v-card-title>
          <v-card-text class="pt-0">
            <div>Info: {{ vendor.info || 'n/a' }}</div>
            <div>Company: {{ vendor.company_name || 'n/a' }}</div>
            <div>Contact: {{ vendor.contact_name || 'n/a' }}</div>
            <div>
              Phone:&nbsp;
              <a :href="`tel:${vendor.phone_number}`">
                {{ vendor.phone_number }}
              </a>
            </div>
            <div>
              Mobile:&nbsp;
              <a :href="`tel:${vendor.mobile_number}`">
                {{ vendor.mobile_number }}
              </a>
            </div>
            <div>
              Email:&nbsp;
              <a :href="`mailto:${vendor.email}`" target="_blank">
                {{ vendor.email }}
              </a>
            </div>
            <div>
              Website:&nbsp;
              <a :href="vendor.website" target="_blank">
                {{ vendor.website }}
              </a>
            </div>
          </v-card-text>
        </v-card>
        <v-alert
          :value="vendorsError"
          color="error"
          icon="warning"
          outline
          class="flex mt-3 xs12 sm12 lg10 offset-lg1 xl8 offset-xl2"
        >
          {{ vendorsError }}
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { getVendors } from '../api/vendors';

export default {
  name: 'ResourceVendor',
  computed: {
    ...mapGetters({
      vendorsError: 'vendorsError',
      vendors: 'vendors',
    }),
  },
  created() {
    this.getVendors();
  },
  methods: {
    ...mapMutations(['showSnackbar', 'closeSnackbar']),
    vendorIcon(type) {
      switch (type) {
        case 'Electrician':
          return 'fas fa-plug';
        case 'Concrete':
          return 'fas fa-user-hard-hat';
        case 'Covered Patios':
          return 'fas fa-construction';
        case 'Heating and Cooling':
          return 'fas fa-thermometer-empty';
        case 'Landscaper':
          return 'fas fa-digging';
        case 'Painter':
          return 'fas fa-paint-roller';
        case 'Plumber':
          return 'fas fa-bath';
        case 'Window Coverings':
          return 'fas fa-sun';
        default:
          return 'fas fa-toolbox';
      }
    },
    getVendors() {
      if (window.sessionStorage.getItem('vendors') === null) {
        this.$store.dispatch('vendors');
        getVendors()
          .then((res) => {
            this.$store.commit('vendorsSuccess', res);
            this.vendorsSuccess();
          })
          .catch((error) => {
            this.vendorsFailed();
            this.$store.commit('vendorsFailed', { error });
          });
      } else {
        JSON.parse(window.sessionStorage.getItem('vendors'));
      }
    },
    vendorsSuccess() {
      this.showSnackbar({
        text: 'Vendors loaded successfully!',
        color: 'success',
        timeout: 5000,
      });
    },
    vendorsFailed() {
      this.showSnackbar({
        text: 'There were problems getting the vendors!',
        color: 'warning',
        timeout: 5000,
      });
    },
  },
};
</script>
